import React from 'react';
import { projectImages } from '../data/mock';
import { useLanguage } from '../i18n/LanguageContext';

const Projects = () => {
  const { t } = useLanguage();
  const projectItems = t('projects.items');
  const statusLabels = t('projects.status');

  const getStatusLabel = (statusKey) => {
    if (typeof statusLabels === 'object' && statusLabels[statusKey]) {
      return statusLabels[statusKey];
    }
    return statusKey;
  };

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <div className="projects-header">
          <span className="section-label">{t('projects.label')}</span>
          <h2 className="section-title">{t('projects.title')}</h2>
        </div>
        
        <div className="projects-grid">
          {Array.isArray(projectItems) && projectItems.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-image-wrapper">
                <img
                  src={projectImages[index]}
                  alt={project.title}
                  className="project-image"
                />
                <div className="project-status">
                  <span className={`status-badge ${project.status === 'active' ? 'active' : ''}`}>
                    {getStatusLabel(project.status)}
                  </span>
                </div>
              </div>
              
              <div className="project-content">
                <span className="project-category">{project.category}</span>
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
